//rule: alphabetic order
export const carrierCodeResources = {
    Loggi: 'LOG_VIP',
    TotalExpress: 'EXP',
    JTExpress: 'J&T_WS',
};

export const carrierNameResources = {
    Loggi: 'Loggi',
    TotalExpress: 'Total Express',
    JTExpress: 'J&T Express',
};